import { atom } from "recoil";

// CourceVenueのアンケート有無
export const isSurveyState = atom({
  key: "isSurveyState",
  default: {
    id: null,
    is_survey: false,
  }
});